import React,{useState} from 'react'
import {BiChevronDown} from 'react-icons/bi'
import {AiOutlineSearch} from 'react-icons/ai'
import {MdAddBox} from 'react-icons/md'
import CustomerSelectorItem from '../CustomerSelectorItem';


const MwSelector = ({label,_data,dataType,onClickNew,setSelectedItem,selectedItem,initalValue='Choose',withSearch=true,withLabel=true,withAddNew=true,className,styleList,invalid,invalidMsg}) => {
    const [inputValue,setInputValue] = useState('');
    const [open,setOpen] = useState(false);

    const onSelectedHandler = (item) => {
        setSelectedItem({...item,label:item.label})
        setOpen(false);
        setInputValue("")
    }
    const dataList = _data &&  _data?.map((item,index) => {
        if(dataType === 'customer' || dataType === 'salesman'){
            return <CustomerSelectorItem 
                        key={item._id}
                        item={item} 
                        setSelectedItem={setSelectedItem} 
                        setOpen={setOpen}
                        setInputValue={setInputValue}
                        inputValue={inputValue}
                        />
        }

        if(dataType === 'labelValue' ){
            // if(item?.lang?.trim() === currentLangId )
                return <div 
                            className={`cursor-default border-t border-slate-100 px-4 py-2 text-sm text-slate-700 transition-colors hover:bg-[#251658]/5 hover:text-[#251658] ${item?.label?.toLowerCase().startsWith(inputValue) ? 'block' : 'hidden'}`}
                            key={index}
                            onClick={()=>onSelectedHandler(item)}
                            >
                            {item.label}
                        </div>
        }
        return null;
    })
    return (
        <>
            <div className={` z-10 ${open && ' relative '} ${className}`}>
                {withLabel && <label className='mb-1 block px-1 text-xs font-medium text-[#251658]'> {label} </label>}
                <div
                    onClick={()=>setOpen(!open)}
                    className={`relative flex h-11 w-full cursor-default items-center rounded-xl border bg-white px-3 text-xs text-slate-700 transition-all duration-200 ${invalid ? 'border-red-400' : 'border-slate-200 hover:border-slate-300'} ${styleList || ''}`} >
                        <span className="w-full text-center font-medium">
                        {(selectedItem && selectedItem !== 'sub'  ? <span className='font-medium text-[#251658]'> {selectedItem.label} </span> : <span className='text-slate-500'>{initalValue}</span>) || initalValue}
                        </span> <BiChevronDown size={20} className="text-slate-500"/>
                </div>
                <ul className={`absolute z-50 w-screen overflow-y-auto rounded-2xl border border-slate-200 bg-white shadow-xl md:w-full md:pe-0 ${open ? 'mt-2 block max-h-60' : 'hidden max-h-0'} pe-12`}>                 
                {withSearch && <div className='sticky top-0 border-b border-slate-100 bg-white p-3'>
                        { 
                        withAddNew && <div className='text-end'>
                            <div className='absolute top-4 end-4 text-[#251658]'  
                            onClick={()=>{ 
                                onClickNew()
                                setOpen(false) 
                            }}
                            > <MdAddBox size={24}/> </div>
                        </div>
                        }
                        <div className='flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-3'>
                            <AiOutlineSearch size={18} className='text-slate-500' />
                            <input 
      type="text"
      placeholder={label}
      className='w-full bg-transparent p-2 text-sm text-slate-700 outline-none placeholder:text-slate-400'
      value={inputValue}
      onChange={(e)=>setInputValue(e.target.value.toLowerCase())}
      />
                        </div>
                    </div> }
                    <div className='mb-2 bg-white'>
                        {dataList}
                    </div>
                </ul>
                { invalidMsg && <div className='px-1 pt-1 text-xs text-red-500'>{invalidMsg}</div> }
            </div>
        </>
    )
}

export default MwSelector
